import FilterListIcon from "@mui/icons-material/FilterList"
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from "@mui/material"
import { styled } from "@mui/system"
import PropTypes from "prop-types"
import React, { memo } from "react"

import { FilterBox } from "@/library"
import { SESSION_TYPES, SESSION_TYPES_LABELS } from "./constants"

const FilterContainer = styled(FilterBox)({
  marginBottom: "1rem",
  boxShadow: "none",
  padding: 0,
  "&:hover": {
    boxShadow: "none",
  },
})

const FilterSection = styled(Grid)({
  alignItems: "flex-end",
})

const CalendarFilters = memo(props => {
  const { selectedValues, validationError, handleResetFilters, handleTypeChange, renderAutocomplete, activeFilters } =
    props
  return (
    <FilterContainer>
      <Box display="flex" justifyContent="start" gap={2} alignItems="center" mb={2}>
        <Box display="flex" alignItems="center">
          <Typography variant="h6" component="h2">
            <FilterListIcon sx={{ mr: 1, verticalAlign: "middle" }} />
            Filters
          </Typography>
        </Box>

        {activeFilters && (
          <Tooltip title="Reset all filters">
            <Button variant="outlined" color="primary" onClick={handleResetFilters} size="small">
              Reset
            </Button>
          </Tooltip>
        )}
      </Box>

      {validationError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {validationError}
        </Alert>
      )}

      <FilterSection container spacing={3}>
        <Grid item xs={12} sm={8} md={4}>
          {renderAutocomplete("Tutor", "tutor_id")}
        </Grid>
        <Grid item xs={12} sm={8} md={4}>
          {renderAutocomplete("School", "school_id")}
        </Grid>
        <Grid item xs={12} sm={8} md={4}>
          {renderAutocomplete("Group/Student", "group_id")}
        </Grid>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <RadioGroup row value={selectedValues.type} onChange={handleTypeChange}>
              {Object.entries(SESSION_TYPES).map(([key, value]) => (
                <FormControlLabel key={key} value={value} control={<Radio />} label={SESSION_TYPES_LABELS[key]} />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
      </FilterSection>
    </FilterContainer>
  )
})

CalendarFilters.displayName = "CalendarFilters"

CalendarFilters.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
  initialFilters: PropTypes.shape({
    tutor_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    school_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    group_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.oneOf(Object.values(SESSION_TYPES)),
  }),
}

export default CalendarFilters
